var _linearGradient, _clipPath, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlexa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 48,
    viewBox: "0 0 48 48",
    width: 48,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 24,
    x2: 24,
    y1: 48,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0174b1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0bbdfe"
  }))), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    height: 48,
    rx: 8,
    width: 48
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h48v48h-48z",
    fill: "url(#a)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m11.4839 27.626c.1997-.04.4202.1514.575.25.311.225.768.605 1.1.8 5.4293 3.7702 13.7658 4.1803 19.75 1.35.242-.118.729-.363.975-.475.1661-.0415.3691-.0559.5.075.576.5759-1.1188 1.5932-1.45 1.85-5.4716 3.7442-13.9656 3.4255-19.175-.55-.737-.582-2.533-2.118-2.55-3.05.048-.102.16-.227.275-.25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m32.559 27.901c1.1348-.6895 2.4306-.8039 3.7-.55.459.131.953.331 1 .875.054 1.283-.474 2.564-1.4 3.45-.2247.2392-.9177 1.0175-1.225.5-.2266-.3817.3368-1.0112.5-1.325.2049-.432.9387-1.6162.5415-2.0702-.3833-.4382-1.5407-.2572-2.0415-.1798-.3548.0579-1.1406.3562-1.45.075-.3051-.2774.1626-.6214.375-.775z"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m9.63686 17.1021c.88594-.7499 2.22304-.8839 3.32504-.65.9849.224 1.623.8111 1.925 1.775.267.5382.1772 5.2009.1545 6.2086-.0024.1084-.0909.1914-.1994.1914h-1.4044c-.0934 0-.1743-.0646-.195-.1557l-.2307-1.0193c-.2242.3289-.4195.7117-.75.95-.663.48-1.579.539-2.32504.225-1.34096-.545-1.619-2.313-1.075-3.525.72-1.4529 2.61304-1.7519 4.07504-1.55 0-.7193-.1286-1.6002-1.009-1.6449-.6458-.0327-1.0433.4558-1.2782 1.0101-.0385.091-.1344.1455-.2313.1262l-1.42852-.2857c-.08992-.018-.15758-.0951-.15087-.1865.04024-.5486.4161-1.1057.79785-1.4692zm3.30004 3.575c-.1671-.0529-.5741-.056-.75-.05-.775.0265-1.45.5741-1.45 1.275 0 .3551.0285.6197.175.95.41.576 1.19.565 1.625.025.4389-.596.465-1.491.4-2.2z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m34.0089 17.101c.886-.75 2.223-.884 3.325-.65.985.224 1.623.811 1.925 1.775.2671.5381.1773 5.2007.1546 6.2085-.0024.1084-.091.1915-.1994.1915h-1.4044c-.0934 0-.1744-.0647-.195-.1559l-.2308-1.0191c-.2241.3288-.4194.7116-.75.95-.663.48-1.579.539-2.325.225-1.3409-.545-1.619-2.313-1.075-3.525.72-1.453 2.613-1.752 4.075-1.55 0-.7194-.1285-1.6003-1.009-1.6449-.6457-.0328-1.0432.4558-1.2781 1.01-.0385.091-.1344.1456-.2313.1262l-1.4285-.2857c-.09-.0179-.1576-.095-.1509-.1865.0402-.5486.4161-1.1056.7978-1.4691zm3.3 3.575c-.167-.053-.574-.056-.75-.05-.7749.0264-1.45.574-1.45 1.275 0 .355.0285.6196.175.95.41.576 1.19.565 1.625.025.439-.596.465-1.491.4-2.2z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    clipRule: "evenodd",
    d: "m20.084 23.376c-1.847-2.69-.218-7.868 3.6-6.925 1.766.444 2.546 2.295 2.575 3.975-.005.244.08.8009-.325.75l-4.425.025c.025.899.141 1.95 1.3 1.95.9 0 1.1269-.5039 1.3296-1.0759.035-.0986.1395-.1541.2405-.1269l1.4944.4028c.1036.0279.1672.1338.1375.2369-.7543 2.6157-4.3977 3.0043-5.927.7881zm4.025-3.55c.005-.81-.438-1.96-1.425-1.825-.786.179-1.048 1.127-1.15 1.825z",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m18.1576 13.901c.111 0 .2007.0904.2.2014l-.0722 10.325c-.0008.1099-.0901.1986-.2.1986h-1.601c-.1106 0-.2002-.0898-.2-.2004l.0241-10.325c.0003-.1103.0898-.1996.2-.1996z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m29.5089 18.951 1.15-2.4 1.7282-.0008c.146-.0001.2428.1513.1816.2839l-1.6598 3.5919 1.791 3.874c.0005.001.1496.326-.1.326h-1.841l-1.25-2.625-1.225 2.625h-1.7c-.334-.0001-.175-.425-.175-.425l1.775-3.75-1.7-3.725c-.0013-.0027-.0819-.176.175-.175.2584.001 1.8169-.0249 1.825-.025z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlexa);
export default __webpack_public_path__ + "static/media/alexa.22ba1d7e3084154def7fc54fcd92c8f9.svg";
export { ForwardRef as ReactComponent };